"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constrainToBounds = exports.isOffScreen = exports.setZoomOffset = exports.getZoom = exports.setCameraXY = exports.update = exports.centerInScreen = exports.getCenterXY = exports.centerOn = exports.getCameraGameBounds = exports.getGameBounds = exports.getAdjustedMousePosition = exports.getUiMousePosition = exports.get = void 0;
var imports_1 = require("../../../lib/imports");
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
var common_sidecar_1 = require("../../../main/common-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
require("./rogueCameraMover-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function create() {
    var size = 10000;
    var obj = {
        zoom: 1,
        cameraX: 0,
        cameraY: 0,
        bounds: {
            x: -size / 2,
            y: -size / 2,
            w: size,
            h: size,
        },
    };
    return obj;
}
function getUiMousePosition() {
    var s = common_sidecar_1.common.getPhaserScene();
    var mx = s.input.mousePointer.x;
    var my = s.input.mousePointer.y;
    return { mx: mx, my: my };
}
exports.getUiMousePosition = getUiMousePosition;
function getAdjustedMousePosition() {
    var s = common_sidecar_1.common.getPhaserScene();
    var mx = s.input.mousePointer.x;
    var my = s.input.mousePointer.y;
    var obj = get();
    var x = (mx + obj.cameraX) / obj.zoom;
    var y = (my + obj.cameraY) / obj.zoom;
    return { max: x, may: y };
}
exports.getAdjustedMousePosition = getAdjustedMousePosition;
function getGameBounds() {
    var scale = common_sidecar_1.common.getPhaserScene().sys.game.scale;
    return { width: scale.width, height: scale.height };
}
exports.getGameBounds = getGameBounds;
function getCameraGameBounds() {
    var scale = common_sidecar_1.common.getPhaserScene().sys.game.scale;
    var obj = get();
    return {
        x1: obj.cameraX,
        y1: obj.cameraY,
        x2: obj.cameraX + scale.width,
        y2: obj.cameraY + scale.height,
        width: scale.width,
        height: scale.height,
    };
}
exports.getCameraGameBounds = getCameraGameBounds;
function centerOn(x, y) {
    var obj = get();
    var gb = getGameBounds();
    setCameraXY(x * obj.zoom + gb.width / 2, y * obj.zoom + gb.height / 2);
}
exports.centerOn = centerOn;
var getCenterXY = function () {
    var obj = get();
    var gb = getGameBounds();
    return {
        x: (obj.cameraX + gb.width / 2) / obj.zoom,
        y: (obj.cameraY + gb.height / 2) / obj.zoom, // / data.zoom,
    };
};
exports.getCenterXY = getCenterXY;
var centerInScreen = function () {
    var obj = get();
    var gs = common_sidecar_1.common.getGameSize();
    var sw = (rogueDef_sidecar_1.rogueDef.screenWidth - 1) * rogueDef_sidecar_1.rogueDef.sizeX * obj.zoom;
    var sh = rogueDef_sidecar_1.rogueDef.screenHeight * rogueDef_sidecar_1.rogueDef.sizeY * obj.zoom;
    setCameraXY(-(gs.width - sw) / 2, -(gs.height - sh) / 2);
    // centerOn(sw / 2, sh / 2)
};
exports.centerInScreen = centerInScreen;
function update() {
    var obj = get();
    // rogueCameraMover.update(obj)
    (0, exports.centerInScreen)();
    _updateLayers();
    // let ap = common.getPhaserScene().game.input.activePointer
}
exports.update = update;
function _updateLayers() {
    var obj = get();
    var layers = rogueLayers_sidecar_1.rogueLayers.getLayersOnMainCamera();
    var cx = obj.cameraX; // + gs.shakeX
    var cy = obj.cameraY; // + gs.shakeY
    // console.log('klayers?', layers.length)
    imports_1.l.forEach(layers, function (c) {
        c.x = -cx;
        c.y = -cy;
        c.setScale(obj.zoom);
    });
}
function setCameraXY(x, y) {
    var _a;
    var obj = get();
    var bounded = (_a = constrainToBounds(x, y, obj.bounds), x = _a.x, y = _a.y, _a);
    x = bounded.x;
    y = bounded.y;
    obj.cameraX = Math.floor(x);
    obj.cameraY = Math.floor(y);
    _updateLayers();
}
exports.setCameraXY = setCameraXY;
function getZoom() {
    return get().zoom;
}
exports.getZoom = getZoom;
function setZoomOffset(zoomOffset) {
    var obj = get();
    var zoomScale = 1 / 16;
    var newZoom = obj.zoom + zoomOffset * zoomScale;
    newZoom = mathUtils_sidecar_1.mathUtils.clamp(newZoom, 0.25, 4);
    obj.zoom = newZoom;
    // let layers = rogueLayers.getLayersOnMainCamera()
    // l.forEach(layers, (c) => {})
    // _updateLayers()
    (0, exports.centerInScreen)();
}
exports.setZoomOffset = setZoomOffset;
function isOffScreen(sprite, tolerance) {
    if (tolerance === void 0) { tolerance = 150; }
    var gb = getGameBounds();
    var obj = get();
    // TODO: width / 2?
    if (sprite.x + sprite.width * sprite.scale + tolerance < 0 + obj.cameraX ||
        sprite.x - sprite.width * sprite.scale - tolerance > gb.width + obj.cameraX) {
        return true;
    }
    if (sprite.y + sprite.height * sprite.scale + tolerance < 0 + obj.cameraY ||
        sprite.y - sprite.height * sprite.scale - tolerance >
            gb.height + obj.cameraY) {
        return true;
    }
    return false;
}
exports.isOffScreen = isOffScreen;
function constrainToBounds(x, y, bounds) {
    var ix = x;
    var iy = y;
    var gb = getGameBounds();
    if (ix < bounds.x) {
        ix = bounds.x;
    }
    if (iy < bounds.y) {
        iy = bounds.y;
    }
    if (iy > bounds.y + bounds.h - gb.height) {
        iy = bounds.y + bounds.h - gb.height;
    }
    if (ix > bounds.x + bounds.w - gb.width) {
        ix = bounds.x + bounds.w - gb.width;
    }
    x = ix;
    y = iy;
    return { x: x, y: y };
}
exports.constrainToBounds = constrainToBounds;
